import React from 'react'
import styled from 'styled-components'
import { Breadcrumbs } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { selectOpen, selectPath, selectSelectedDashboardNode, setPath, setSelectedDashboard, setSelectedDashboardId, setSelectedDashboardNode, setSelectedTreeNode } from '../ducks/navigationSlice';

type BreadcrumbProps = {
    padding?: number
    homeId: string
}
const Breadcrumb: React.FC<BreadcrumbProps> = ({ homeId, padding = 0 }) => {
    const dispatch = useAppDispatch()
    const open = useAppSelector((state) => selectOpen(state))
    const paths = useAppSelector((state) => selectPath(state))
    const selectedDashboardNode = useAppSelector((state) => selectSelectedDashboardNode(state))

    const onSelectDashboard = (path: DashboardNode[], dashboard?: Dashboard) => {
        if (selectedDashboardNode.id === homeId) return;
        dispatch(setSelectedDashboard(dashboard))
        dispatch(setPath(path))

        dispatch(setSelectedTreeNode(path[path.length - 1].id))
        dispatch(setSelectedDashboardId(undefined))
        
        if (!dashboard) {
            dispatch(setSelectedDashboardNode(path[path.length - 1]))
        }
    }
    
    const mountLink = (paths: DashboardNode[]) => {
        return paths?.map((path, index, array) => {
            return (
                <div key={index}>
                    {
                        path.id === homeId
                        ? <StyledHomeDiv 
                            isHome={homeId === selectedDashboardNode.id}
                            onClick={() => onSelectDashboard([path], path.showPage ? undefined : path.dashboards[0])}
                        >
                            <i 
                                style={{
                                    fontSize: 15
                                }}
                                className="fas fa-home"
                            />
                            <span 
                                style={{ marginLeft: 5, fontSize: 12 }}
                            >
                                Home
                            </span>
                        </StyledHomeDiv>
                        : <StyledLink
                            onClick={() => onSelectDashboard(array.slice(0, index + 1), path.showPage ? undefined : path.dashboards[0])}
                            disabled={index === paths.length - 1}
                        >
                            {path.pageName}
                        </StyledLink>
                    }
                </div>
            )
        })
    }

    return (
        <StyledNav sidebarOpen={open} padding={padding}>
            <Breadcrumbs
                classes={{ li: "liClass", ol: "olClass" }}
                maxItems={12}
                itemsBeforeCollapse={2}
                itemsAfterCollapse={2}
                slotProps={{
                    collapsedIcon: {
                        style: { backgroundColor: "var(--gray-200)" }
                    }
                }}
            >
                {mountLink(paths)}
            </Breadcrumbs>
        </StyledNav>
    )
}

const StyledNav = styled.div<{ sidebarOpen: boolean, padding: number }>`
    box-shadow: none;
    width: 100%;
    height: 37px;
    background: var(--gray-200);
    border-bottom: 1px solid var(--gray-300);
    display: flex;
    padding-left: 10px;
    /* margin-left: ${props => props.sidebarOpen ? 0 : 32}px; */
    align-items: center;
    overflow-x: auto;
    border-left: 1px solid var(--gray-400);
    padding-right: 42px;

    &::-webkit-scrollbar {
       display: none;
    }

    .liClass {
        justify-content: center;
        display: flex;
        white-space: nowrap;
    }

    .olClass {
        flex-wrap: nowrap;
    }
`

const StyledLink = styled.span<{ disabled: boolean }>`
    cursor: ${props => props.disabled ? "default" : "pointer"};
    color: ${props => props.disabled ? "var(--gray-800)" : "var(--blue-500)"};
    font-size: 12px;
    font-weight: 600;

    :hover {
        text-decoration: ${props => props.disabled ? "none" : "underline"};
    }
`

const StyledHomeDiv = styled.div<{ isHome: any }>`
    color: ${props => !props.isHome ? "var(--blue-500)" : "var(--gray-800)"};
    cursor: ${props => !props.isHome ? "pointer" : ""};
    font-weight: 600;

    :hover {
        text-decoration: ${props => !props.isHome ? "underline" : "none"};
    }
`

export default Breadcrumb
